<template>
  <v-footer
    class="ctk-footer"
  >
    <template>
      <v-container grid-list-md text-center>
        <v-layout wrap class="hidden-sm-and-down">
          <v-flex md12 style="margin-bottom: 60px;">
            <v-layout wrap class="footer-menus">
              <v-flex md1></v-flex>
              <v-flex md2 v-for="(menu, index) in menus" :key="index">
                <a :href="'/#' + menu.link">{{menu.title}}</a>
              </v-flex>
              <v-flex md1></v-flex>
            </v-layout>
          </v-flex>
          <v-flex md12 style="margin-bottom: 40px;">
            <div style="width: 970px; margin: 0 auto;">
              <div class="footer-logo">
                <img height="100" :src="info.logo" />
              </div>
              <div class="footer-qrcode">
                <img height="100" :src="info.qrcode" />
              </div>
              <div class="footer-contact">
                <div><span class="footer-title">电话: </span><span class="footer-value">{{info.tel}}</span></div>
                <div><span class="footer-title">邮箱: </span><span class="footer-value">{{info.email}}</span></div>
                <div><span class="footer-title">地址: </span><span class="footer-value">{{info.addr}}</span></div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 text-center class="footer-copyright">
            &copy;2021 Citiking All Rights Reserved.<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号: {{info.icp}}</a>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </v-footer>
</template>
<script>
export default {
  data: () => ({
    menus: []
  }),
  created () {
    this.menus = this.$parent.$parent.menus
  },
  computed: {
    info () {
      let links = []
      if (this.$store.getters.companyInfo.link) {
        links = this.$store.getters.companyInfo.link.filter(ele => ele.type === 0)
      }
      let info = this.$store.getters.companyInfo
      info.links = links
      return info
    }
  }
}
</script>
